import { render, staticRenderFns } from "./psiModal.vue?vue&type=template&id=17876cfc&scoped=true"
import script from "./psiModal.vue?vue&type=script&lang=js"
export * from "./psiModal.vue?vue&type=script&lang=js"
import style0 from "./psiModal.vue?vue&type=style&index=0&id=17876cfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17876cfc",
  null
  
)

export default component.exports